import { render, staticRenderFns } from "./NewUcaLandingPage.vue?vue&type=template&id=f8763dfa&scoped=true"
var script = {}
import style0 from "./NewUcaLandingPage.vue?vue&type=style&index=0&id=f8763dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8763dfa",
  null
  
)

export default component.exports